
import React from 'react'
import {getUserSettings, getUserProfile} from '../../../storage'
import moment from 'moment'
import {MEDIA_URL} from '../../../constants'
import {InvoiceSerialGenerator} from '../utils'
export function HeaderStyle1(props) {

  let company = props.company
  let company_gstin, company_state_code, additional_params, invoice_label = "INVOICE"

  let purchase_order, invoice_additional_params
  let settings = props.settings || getUserSettings()
  let options = settings.options
  let invoice = props.invoice
  let serial = invoice.serial

  serial = <InvoiceSerialGenerator options={options} series_name={invoice.series_name} series_counter={invoice.series_counter} />

  let invoice_date = moment(invoice.date).format('D-MM-YYYY')

  if(settings.invoice_label) {
    invoice_label = <span>{settings.invoice_label}</span>
  }

  if(typeof company.gstin !== "undefined" && company.gstin.length > 0) {
    company_gstin = <span className="gray">{"GSTIN-" +company.gstin}</span>
  }


  if(company.state_code) {
      company_state_code = <span className="gray"> State Code: {company.state_code}</span>
  }
  if(company.additional_params && company.additional_params.length) {
      let additional_params_list = company.additional_params.map(function(param, i) {
        return <li key={i}><span className="gray">{param.key} {param.value}</span></li>
      })
      additional_params= <ul className="list-inline" style={{marginBottom:0}}>{additional_params_list}</ul>
  }

  if(typeof invoice.additional_params !== "undefined" && invoice.additional_params !== null) {
    let additional_params_list = invoice.additional_params.map(function(param, i) {
      if(param.key === "sez_without_tax") {
        return null
      }
      else {
          return <div key={i}><span className="gray">{param.key} {param.value}</span></div>
      }

    })
    invoice_additional_params= <div style={{marginBottom:0}}>{additional_params_list}</div>
  }

  if(options && options.enable_invoice_purchase_order) {
    purchase_order = <div>Purchase Order: {invoice.purchase_order_no}</div>
  }

  return   <div className="row">
      <div className="col-xs-6">
      <div className="company-name text-uppercase">
      {company.company_name}
      </div>
        <div className="">
        <div className="company-address gray">
          {company.address}
        </div>
        <div className="company-address gray">
          <span className="company-state gray">{company.city}</span>
          <span className="company-state gray">{" "+company.state}</span>
          <span className="company-pin gray">{" "+ company.pin}</span>
        </div>

        <div className="company-email gray">
          {company.email}
        </div>
        <div className="company-phone gray">
          {company.phone}
        </div>
        <div className="company-state gray">
         {company_gstin} {company_state_code}
        </div>
        <div className="company-state gray">
         {additional_params}
        </div>
        </div>

      </div>
      <div className="col-xs-6">
      <div className="invoice-name text-right">
        {invoice_label}
      </div>
        <div className="text-right invoice-name">{serial}</div>
        <div className="gray text-right">
        Date: {invoice_date}
        </div>
        <div className="gray text-right">
          {purchase_order}
        </div>
        <div className="text-right gray">
            {invoice_additional_params}
        </div>
      </div>


    </div>

}

export function LogoHeader(props){
  let company = props.company

  let invoice = props.invoice
  let historyRecords = props.history
  let settings = props.settings || getUserSettings()
  let brandRow = <small><i>Generated with https://www.goodsbill.com</i></small>

  let billto_1, billto_2, billFrom
  let place_of_supply
  let shipping_address
  let optionalRow = false
  let table_cols = 6
  let invoice_label = "INVOICE"
  let show_mrp_column = false
  let show_container_unit = false
  let serial = invoice.series_name + invoice.series_counter

  let logo1, logo2, company_gstin, company_tag_line, company_address, company_name, company_phone
  if(company.logo) {
    logo1 = <img src={MEDIA_URL+company.logo} className="img-thumbnail" style={{border:0}}/>
  }
  if(typeof company.company_name !== "undefined" && company.company_name.length > 0) {
    company_name = <div className="company-name text-uppercase" style={{fontSize:26, fontWeight:400, fontFamily:"serif"}}>

                    {company.company_name}
                  </div>
  }
  if(typeof company.gstin !== "undefined" && company.gstin.length > 0) {
    company_gstin = <span><strong>{"GSTIN: " +company.gstin}</strong></span>
  }
  if(company.tag_line) {
    company_tag_line = <div style={{fontSize:16}}>
            {company.tag_line}
    </div>
  }
  if(typeof company.phone !== "undefined" && company.phone.length > 0) {
    company_phone = <span >{"Ph: " +company.phone}</span>
  }
  company_address = <div className="space-small-bottom">
  <div>
  <strong>{company.address}</strong>
  </div>
  <div>
  <strong>{company.city} {company.state} {company.pin}</strong>
  </div>
  </div>

  return <div className="row">
        <div style={{position:'absolute', width:100, paddingLeft:15, paddingTop:5}}>
        {logo1}
        </div>
        <div className="col-xs-12 text-center" style={{position:'relative'}}>
          {company_name}
          <div>
          {company_tag_line}
          </div>
          <div className="text-center">
          {company_address}
          </div>
          <div className="text-center">
          {company_gstin}
          </div>

          <div className="text-center">
          {company_phone}
          </div>

        </div>

  </div>

}

export function HeaderStyle2(props) {

    let company = props.company
    let company_gstin,company_phone, company_email, company_state_code, company_additional_params, invoice_label = "INVOICE"

    let company_address, company_tag_line, company_name

    let purchase_order, invoice_additional_params
    let settings = props.settings || getUserSettings()
    let options = settings.options
    let invoice = props.invoice
    let serial = invoice.serial

    let invoice_date = moment(invoice.date).format('D-MM-YYYY')
    serial = <InvoiceSerialGenerator options={options} series_name={invoice.series_name} series_counter={invoice.series_counter} />
    if(settings.invoice_label) {
      invoice_label = <div className="" style={{fontFamily:'serif'}}>
         <span>{settings.invoice_label}</span>
      </div>
    }

    if(typeof company.gstin !== "undefined" && company.gstin.length > 0) {
      company_gstin = <span className="gray">{"GSTIN-" +company.gstin}</span>
    }

    if(typeof company.phone !== "undefined" && company.phone.length > 0) {
      company_phone = <span >{"Ph: " +company.phone}</span>
    }
    if(typeof company.email !== "undefined" && company.email.length > 0) {
      company_email = <span >{"Email: " +company.email}</span>
    }

    if(company.state_code) {
        company_state_code = <span className="gray"> State Code: {company.state_code}</span>
    }
    if(company.additional_params && company.additional_params.length) {
        let additional_params_list = company.additional_params.map(function(param, i) {
          return <li key={i}><span className="gray">{param.key} {param.value}</span></li>
        })
        company_additional_params= <ul className="list-inline" style={{marginBottom:0}}>{additional_params_list}</ul>
    }

    if(typeof invoice.additional_params !== "undefined" && invoice.additional_params !== null) {
      let additional_params_list = invoice.additional_params.map(function(param, i) {
        if(param.key === "sez_without_tax") {
          return null
        }
        else {
            return <div key={i}><span className="gray">{param.key} {param.value}</span></div>
        }

      })
      invoice_additional_params= <div style={{marginBottom:0}}>{additional_params_list}</div>
    }

    if(options && options.enable_invoice_purchase_order) {
      purchase_order = <div>Purchase Order: {invoice.purchase_order_no}</div>
    }

    let logo1, logo2
    if(company.logo) {
      logo1 = <img src={MEDIA_URL+company.logo} className="img-thumbnail" style={{border:0}}/>
    }
    if(company.logo_2) {
      logo2 = <img src={MEDIA_URL+company.logo_2} className="img-thumbnail"style={{border:0}}/>
    }
    if(typeof company.company_name !== "undefined" && company.company_name.length > 0) {
      company_name = <div className="company-name text-uppercase" style={{fontSize:26, fontWeight:400, fontFamily:"serif"}}>

                      {company.company_name}
                    </div>
    }

    if(company.tag_line) {
      company_tag_line = <div style={{fontSize:16}}>
              {company.tag_line}
      </div>
    }

    let header_1 =<div className="row">
            <div className="col-xs-6">
              {company_gstin} {company_additional_params}
            </div>
            <div className="col-xs-6 text-right">
              {company_phone}
            </div>
    </div>
    company_address = <div className="space-small-bottom"> {company.address} {company.city} {company.state} {company.pin}</div>



    return  <div className="row">
          <div className="col-xs-12">
          {header_1}
          </div>

          <div className="col-xs-2">

          {logo1}
          </div>
          <div className="col-xs-8 text-center">
            {company_name}
            <div>
            {company_tag_line}
            </div>

            <div className="text-center">
            {company_address}
            </div>
            <div>
            {company_email}
            </div>


          </div>
          <div className="col-xs-2 text-right">

          {logo2}
          </div>

          <div className="col-xs-12">
          <div className="row" style={{fontSize:16, marginTop:10, marginBottom:10}}>
            <div className="col-xs-4">
            Date: {invoice_date}
            </div>
            <div className="col-xs-4 text-center">
            {invoice_label}
            </div>
            <div className="col-xs-4 text-right">
            Invoice No: {serial}
            </div>
          </div>
          </div>

    </div>

}



export default function Partial () {
  return null;
}



// WEBPACK FOOTER //
// ./src/components/invoice/previews/partials.js